import { c as _c } from "react/compiler-runtime";
import { formatCents } from 'betterplace-utils';
import { Heading } from '../../../components/Heading';
import styles from './ModalContent.module.css';
import type { MatchingEventCampaignType } from '../types';
export type MatchingConditionsText = {
  spendenmarathon: string;
  bp_spendenmarathon: string;
  heading: string;
  how_it_works: string;
};
function MatchingConditions(t0) {
  const $ = _c(20);
  const {
    isWW,
    campaignType,
    maximumMatchingAmountInCents,
    text,
    locale
  } = t0;
  if (isWW && campaignType === "SPENDENMARATHON") {
    let t1;
    if ($[0] !== text.how_it_works) {
      t1 = <span className={styles.importantInfo}>{text.how_it_works}</span>;
      $[0] = text.how_it_works;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1 || $[3] !== text.spendenmarathon) {
      t2 = <p className={styles.paragraph}>{t1}{text.spendenmarathon}</p>;
      $[2] = t1;
      $[3] = text.spendenmarathon;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (!isWW && (campaignType === "SPENDENMARATHON" || campaignType === "PROPORTIONAL")) {
    let t1;
    if ($[5] !== text.how_it_works) {
      t1 = <span className={styles.importantInfo}>{text.how_it_works}</span>;
      $[5] = text.how_it_works;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    let t2;
    if ($[7] !== t1 || $[8] !== text.bp_spendenmarathon) {
      t2 = <p className={styles.paragraph}>{t1}{text.bp_spendenmarathon}</p>;
      $[7] = t1;
      $[8] = text.bp_spendenmarathon;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  if (!maximumMatchingAmountInCents) {
    return null;
  }
  let t1;
  if ($[10] !== text.heading) {
    t1 = <Heading as="h3" level="text-md-default">{text.heading}</Heading>;
    $[10] = text.heading;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== locale || $[13] !== maximumMatchingAmountInCents) {
    t2 = formatCents(locale, maximumMatchingAmountInCents);
    $[12] = locale;
    $[13] = maximumMatchingAmountInCents;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== t2) {
    t3 = <p className={styles.importantInfo}>{t2}</p>;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t1 || $[18] !== t3) {
    t4 = <div className={styles.miniParagraph}>{t1}{t3}</div>;
    $[17] = t1;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
export default MatchingConditions;